import { Component } from '@angular/core';
import { NgIcon, provideIcons } from '@ng-icons/core';
import { CP_ICONS } from '../../shared/icons';
import {
  PortalStatus,
  SAMPLE_OPTIONS,
  SAMPLE_REQUESTS,
  STATUS_DOT,
  formatUsd,
} from './sample-data';

/**
 * Static, full-width rendering of the advisor portal (sidebar, request table,
 * request detail). Mirrors the real portal's structure and labels.
 */
@Component({
  selector: 'app-pipeline-preview',
  standalone: true,
  imports: [NgIcon],
  viewProviders: [provideIcons(CP_ICONS)],
  templateUrl: './pipeline-preview.component.html',
})
export class PipelinePreviewComponent {
  readonly requests = SAMPLE_REQUESTS;
  readonly selected = SAMPLE_REQUESTS[0];
  readonly options = SAMPLE_OPTIONS;
  readonly sidebar = [
    { icon: 'phosphorSquaresFour', label: 'Advisor Portal', active: true },
    { icon: 'phosphorPaperPlaneTilt', label: 'Request Terms', active: false },
    { icon: 'phosphorTrendUp', label: 'Buy/Sell Book of Business', active: false },
    { icon: 'phosphorGear', label: 'User Settings', active: false },
  ];

  dot(status: PortalStatus): string {
    return STATUS_DOT[status];
  }

  usd(value: number): string {
    return formatUsd(value);
  }
}
